import { useEffect, useRef, useState } from "react";
import PurchaseOrderMainContainer from "./PurchaseOrderMainContainer"
import { useSelector } from "react-redux";

const PurchaseOrderMainContainer_Container = (props: any) => {
    const { isBulkOrder = false } = props
    const wrapperRef = useRef<any>(null);
    const [selectedKey, setSelectedKey] = useState("fleet-processing");
    const [showFleetBreadcrumb, setShowFleetBreadcrumb] = useState(true);
    const [tabSwitchClicked, setTabSwitchClicked] = useState(false);
    const [tab, setTab] = useState('')
    const { bulkOrderVendorDetails }: any = useSelector((state: any) => ({
      bulkOrderVendorDetails: state.PurchaseBulkOrderReducer.bulkOrderVendorDetails
    }))
    const handleLinkClick = (item?: any) => {
      if (item) {

        if(item.props.itemKey === 'fleet-processing'){
          setSelectedKey(item.props.itemKey);
          setTab(item.props.itemKey)
          setShowFleetBreadcrumb(true)
          setTabSwitchClicked(false)
        } else {
          const fleetBreadCrumb = item.props.itemKey !== 'requisition'
          setTabSwitchClicked(true)
          setShowFleetBreadcrumb(fleetBreadCrumb)
          setTab(item.props.itemKey)
        }
      }
    };
    const activeNavigation = useSelector((state: any) => state.nav.nav)

    useEffect(() => {
        document.getElementsByClassName('content-wrapper')[0].scrollTop = 0;
    }, [activeNavigation]);
    
    return(
        <PurchaseOrderMainContainer 
        wrapperRef={wrapperRef} 
        selectedKey={selectedKey} 
        setSelectedKey={setSelectedKey}
        showFleetBreadcrumb={showFleetBreadcrumb} 
        handleLinkClick={handleLinkClick}
        tabSwitchClicked={tabSwitchClicked}
        setTabSwitchClicked={setTabSwitchClicked}
        setShowFleetBreadcrumb={setShowFleetBreadcrumb}
        isBulkOrder={isBulkOrder}
        bulkOrderVendorDetails = {bulkOrderVendorDetails}
        tab={tab}
        />
    )
}

export default PurchaseOrderMainContainer_Container